// src/hooks/useBlogEntries.js
import { useState, useEffect } from 'react';
import matter from 'gray-matter';

const useBlogEntries = () => {
  const [entries, setEntries] = useState([]);

  useEffect(() => {
    const fetchBlogEntries = async () => {
      try {
        const response = await fetch('/blog/index.json');
        if (!response.ok) {
          throw new Error(`Error fetching index.json: ${response.statusText}`);
        }
        const fileNames = await response.json();

        const fetchedEntries = await Promise.all(
          fileNames.map(async (fileName) => {
            const res = await fetch(`/blog/${fileName}`);
            if (!res.ok) {
              throw new Error(`Error fetching ${fileName}: ${res.statusText}`);
            }
            const text = await res.text();
            const { data, content } = matter(text);
            return {
              id: fileName,
              title: data.title,
              content: content,
              date: data.date,
              tags: data.tags,
              spotify: data.spotify || null,
            };
          })
        );

        setEntries(fetchedEntries);
      } catch (err) {
        console.error('Error fetching blog entries:', err);
      }
    };

    fetchBlogEntries();
  }, []);

  return entries;
};

export default useBlogEntries;
